import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
    selector: 'app-list-editor',
    imports: [],
    templateUrl: './list-editor.component.html',
    styleUrl: './list-editor.component.less',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => ListEditorComponent),
        }
    ]
})
export class ListEditorComponent implements ControlValueAccessor {

  onChange = (value: any) => {}
  onTouched = () => {};

  @Input()
  delimiter: string = ' ';

  @Input()
  hint: string = '';

  touched = false;
  disabled = false;

  listValue!: string[];

  writeValue(obj: any): void {
    this.listValue = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  onBlur(event: Event) {
    this.markAsTouched();
    const inputElement = event.target as HTMLInputElement;
    if (!inputElement.value || !inputElement.value.trim()) {
      return;
    }
    this.listValue.push(inputElement.value.trim());
    inputElement.value = '';
    this.onChange(this.listValue);
  }

  onNewValue(event: Event) {
    this.markAsTouched();
    const inputElement = event.target as HTMLInputElement;
    if (!inputElement.value || !inputElement.value.trim()) {
      return;
    }
    const inputChar = (event as InputEvent).data;
    if (inputChar === this.delimiter) {
      this.listValue.push(inputElement.value.trim());
      inputElement.value = '';
      this.onChange(this.listValue);
    }
  }

  onDeleteValue(index: number) {
    this.markAsTouched();
    this.listValue.splice(index, 1);
    this.onChange(this.listValue);
  }
}
